import { Dialog } from '@/components/ui'
import { useIsTrialAccount } from '@/modules/account'
import { useStatements } from '@/modules/projects/hooks'
import { useIsNarrowScreen } from '../TrialTour/useIsNarrowScreen'
import { UploadGuideContent } from './UploadGuideContent'
import { useUploadGuideSeen } from './useUploadGuideSeen'

export const TrialUploadGuide = () => {
  const isTrial = useIsTrialAccount()
  const hasUploaded = useStatements().length > 0
  // Phones get the notice to continue on a computer instead; the guide waits for that visit.
  const isNarrowScreen = useIsNarrowScreen()
  const { seen, markSeen } = useUploadGuideSeen()

  return (
    <Dialog
      open={isTrial && !isNarrowScreen && !hasUploaded && !seen}
      onOpenChange={(isOpen) => !isOpen && markSeen()}
    >
      <UploadGuideContent onFinish={markSeen} />
    </Dialog>
  )
}
